// extracted by mini-css-extract-plugin
export default {"loader":"ScrollLoder_loader__-OO5z","bar":"ScrollLoder_bar__VnqYm","scale-up4":"ScrollLoder_scale-up4__8C53L"};